import { FaGoogleDrive } from "react-icons/fa";
import { useState } from "react";

import Modal from "../../../../../components/common/Modal";
import CloudStorageForm from "./CloudStorageForm";

const CloudStorage = ({ data, setData }) => {
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloudSuccess = (url) => {
    const account = { ...data };
    account["cloud_storage_url"] = url;

    setData(account);
    setShowForm(false);
  };

  return (
    <div className="px-6 py-5 grid grid-cols-3">
      <dt className="col-span-2">
        <p className="text-gray-400 text-sm">Cloud Storage</p>
        {data.cloud_storage_url && (
          <a
            className="text-sm text-blue-400 flex items-center mt-2"
            href={`${data.cloud_storage_url}`}
            target="_blank"
            rel="noreferrer"
          >
            <FaGoogleDrive /> <span className="ml-2">Google Drive</span>
          </a>
        )}
        {!data.cloud_storage_url && (
          <span className="text-sm text-gray-500">Not available</span>
        )}
      </dt>
      <dd className="col-span-1">
        <div className="float-right">
          <span
            className="text-blue-400 text-sm cursor-pointer"
            onClick={() => setShowForm(true)}
          >
            Edit
          </span>
        </div>
      </dd>
      <Modal
        title="Google Drive"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <CloudStorageForm
          data={data}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleCloudSuccess}
        />
      </Modal>
    </div>
  );
};

export default CloudStorage;
